<template>
  <div>
    <!-- 效果分析 -->
    <el-drawer   
      size="955px"
      :visible.sync="drawerShow"
      :show-close="false"
      title=""
      :destroy-on-close="true"
      ref="drawer"
      custom-class="analysis-drawer"
      class=""
      :withHeader="false"
      :before-close="handleClose"
      :append-to-body="true"
      >
      <el-button 
        size="mini" 
        class="closeBtnAnalysis"
        type="primary"
        @click="handleClose"
      >收起 <i class="iconfont el-icon-download" style="transform: rotate(-90deg)" ></i> </el-button>
      <el-form class="analysis-detail">
        <el-form-item :label="'邮件标题'">
          <div>{{params.name}}</div>
        </el-form-item>
        <el-form-item :label="'营销任务'">
          <div>{{params.title}}</div>
        </el-form-item>
        <el-form-item :label="'发送时间'">
          <div v-if="params.realSendTime==null||params.realSendTime==''">
            {{params.scheduleSendTime | format('YYYY-MM-DD HH:mm')}}
          </div>
          <div v-else>
             {{params.realSendTime | format('YYYY-MM-DD HH:mm')}}
          </div>
          <!-- <div>{{sendModel==1?'立即发送':(scheduleSendTime| format('YYYY-MM-DD HH:mm'))}}</div> -->
        </el-form-item>
      </el-form>
      <div class="cardRowDiv">
        <el-row :gutter="24" class="cardRow">
          <el-col :span="6">
            <el-button
              type="primary"
              :class="cssShow == 'finish' ? 'Active' : 'analysis-conter-card'"
              @click="changeCard('finish')"
            >
              <div class="analysis-conter-card-number">{{sendUserNum}}</div>
              <!-- 邮件发送总数 -->
              <div class="analysis-conter-card-text">
                邮件发送总数
              </div>
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              :class="cssShow == 'view' ? 'Active' : 'analysis-conter-card'"
              @click="changeCard('view')"
            >
              <div class="analysis-conter-card-number">
                {{viewMailUserNum}}
              </div>
              <!-- 查看邮件人数 -->
              <div class="analysis-conter-card-text">
                查看邮件数
              </div>
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              :class="cssShow == 'link' ? 'Active' : 'analysis-conter-card'"
              @click="changeCard('link')"
            >
              <div class="analysis-conter-card-number">
                {{clickMailLinkUserNum}}
              </div>
              <!-- 链接点击人数 -->
              <div class="analysis-conter-card-text">
                链接点击数
              </div>
            </el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              class="analysis-conter-card"
            >
              <div class="analysis-conter-card-number">
                {{viewRatio||0+'%'}}
              </div>
              <!-- 查看率 -->
              <el-popover
                placement="bottom"
                width="200"
                trigger="hover"
              >
                <div class="popver-content">
                  <div class="content">
                    <p>
                     查看率=(查看邮件人数 / 推送成功) * 100%
                    </p>
                  </div>
                </div>
                <div
                  class="analysis-conter-card-text"
                  slot="reference"
                >
                  查看率
                  <i class="iconfont icon-icon-zhuming2"></i>
                </div>
                <!-- <el-button class="el-icon-info"></el-button> -->
              </el-popover>
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 列表 -->
      <!-- 推送完成人数 -->
      <div v-if="cssShow == 'finish'">
        <finishList :emdId="params.emdId" :successNum="successNum" :failNum="failNum"/>
      </div>
      <!-- 查看邮件人数 -->
      <div v-if="cssShow == 'view'">
        <viewList :emdId="params.emdId"/>
      </div>
      <!-- 链接点击人数 -->
      <div v-if="cssShow == 'link'">
        <linkList :emdId="params.emdId" :linkListArr="linkListArr" :clickMailLinkUserNum="clickMailLinkUserNum"/>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import finishList from '@/components/intellect-marketing/analysis/finishList';
import viewList from '@/components/intellect-marketing/analysis/viewList';
import linkList from '@/components/intellect-marketing/analysis/linkList';
import {analysisInfo,viewMailLeads} from"@/utils/api/edmSubject"
export default {
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    params:{
      type:Object,
      default:{}
    }
    // emdId:{
    //   type:Number,
    //   default:0
    // },
    // sendModel:{
    //   type:Number,
    //   default:1
    // },
    // title:{
    //   type:String,
    //   default:''
    // },
    // name:{
    //   type:String,
    //   default:''  
    // },
    // scheduleSendTime:{
    //   type:Number,
    //   default:1
    // }
  },
  components:{
    finishList,
    viewList,
    linkList
  },
  computed: {
    drawerShow: {
      get() {
        return this.visible;
      },
      set(v) {
        // this.$emit('changeShow', v);
      }
    },
  },
  data(){
    return{
      cssShow: "view",
      linkListArr:[],
      sendUserNum:0,//推送完成人数
      viewMailUserNum:0,//查看邮件人数
      clickMailLinkUserNum:0,//链接点击人数
      successNum:0,//推送完成成功人数
      viewRatio:0,//查看率
      failNum:0,//推送完成失败人数
    }
  },
  methods:{
    handleClose(done) {
      // done();
      this.$emit('changeShow', false);
    },
        // 卡片点击
    changeCard(type) {
      console.log(type)
      this.cssShow=type
    },
    // 营销邮件效果分析-数据统计
    async getanalysisInfo(){
      const params={
        id:this.params.emdId
      }
      const res=await analysisInfo(params)
      this.linkListArr=res.data.linkList
      this.sendUserNum=res.data.sendUserNum
      this.viewMailUserNum=res.data.viewMailUserNum
      this.clickMailLinkUserNum=res.data.clickMailLinkUserNum
      this.successNum=res.data.successNum
      this.viewRatio=res.data.viewRatio
      this.failNum=res.data.failNum
    },

  },
  mounted(){
    this.getanalysisInfo()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .analysis-drawer{
  // padding: 24px;
  .analysis-detail{
    padding-left: 24px;
    padding-top: 18px;
    .el-form-item{
      margin-bottom: 4px;
    }
    .el-form-item__label{
      font-size: 12px;
    }
    .el-form-item__content{
      font-size: 12px;
    }
  }
  .cardRow{
    margin:0px !important;
    padding-left: 14px;
  }
  .el-drawer__body{
    overflow-y: scroll !important;
    scrollbar-width: thin;
  }
  /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
}
.Active {
  height: 101px;
  width: 100%;
  background-image: linear-gradient(131deg, #47A0FF 0%, #318CED 100%);
  box-shadow: 0 4px 6px 0 #003b7133;
  border-radius: 8px;
  border: none;
  margin-right: 35px;
  .analysis-conter-card-number {
    // font-family: Arial-BoldMT;
    font-weight: bold;
    // font-size: 100vw * (24/1920);
    font-size: 24px;
    color: #ffffff;
  }
  .analysis-conter-card-text {
    font-family: SourceHanSansCN-Regular;
    font-weight: BoldMT;
    // font-size: 100vw * (12/1920);
    font-size: 14px;
    color: #ffffff;
    margin-top: 12px;
    word-break: break-word;
    white-space: normal;
  }
}
.analysis-conter-card {
  height: 101px;
  width: 100%;
  background-image: linear-gradient(90deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: none;
  // margin-right: 35px;
  .analysis-conter-card-number {
    // font-family: Arial-BoldMT;
    font-weight: Bold;
    // font-size: 100vw * (24/1920);
    font-size: 24px;
    color: #16181A;
  }
  .analysis-conter-card-text {
    font-family: SourceHanSansCN-Regular;
    // font-size: 100vw * (12/1920);
    font-size: 14px;
    color: #999999;
    margin-top: 12px;
    word-break: break-word;
    white-space: normal;
  }
}
.cardRowDiv{
  padding-right: 25px;
  margin-top: 18px;
}
.closeBtnAnalysis{
  position: fixed;
  right: 947px;
  top: 36px; 
  box-shadow: 2px 0 4px 0 rgba(49,140,237,0.3);
  border-radius: 2px;
  background: #318CED;
  border-color: #318CED;
  .iconfont{
    margin-left: 4px;
    font-size: 12px;
  }
}
.closeBtnAnalysis:hover{
  background: #318CED !important;
  border-color: #318CED !important;
  color: #ffffff !important;
}
</style>